import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./HivRemoteTreatment.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getRussiaHiVMigrantsDetails,
  getRussiaHiVMigrantsTreatmentDetails,
} from "../../redux/InformationSlice";
import { useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { Seo } from "../../Seo";

const HivRemoteTreatment = () => {
  const data = useSelector(
    (state: RootState) => state.info.russiaHiVMigrantsTreatmentDetails,
  );

  const params = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    //dispatch(getRussiaHiVMigrantsDetails(Number(params.id)));
    dispatch(getRussiaHiVMigrantsTreatmentDetails(Number(params.id)));
  }, [params]);

  return (
    <div>
      <Seo
        title="Дистанционная постановка на учет для мигрантов с ВИЧ"
        description="Как мигрантам из Кыргызстана и Таджикистана встать на учет по ВИЧ у себя на родине дистанционно"
        url="https://www.vputi.org/russia/hiv/migrants/treatment/remote/2"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство России / ВИЧ / Информация для мигрантов с ВИЧ / Как получать лечение / Дистанционный учёт",
            path: "/russia/hiv/migrants/treatment/2",
          }}
        />

        <ContactButtons />
        <div className={s.text}>
          <div className={s.title}>{data?.title_1}</div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_1 ?? "" }}
          ></div>
          <div className={s.yellow_wrapper}>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: data?.body_2 ?? "" }}
            ></div>
          </div>

          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_3 ?? "" }}
          ></div>
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default HivRemoteTreatment;
